import { AcquisitionConstants } from "applicantTheme/AcquisitionConstants";

export function getAcquisitionClientName(
  applicantThemeAcquisition: string,
): string {
  return AcquisitionConstants.Acquisition.DEFAULT;
}
